
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Weather'
})
export default class Weather extends Vue {}
